import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../App";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import KTBanner from "../../components/KTBanner";

const FIELDS = [
  { id: "name", label: "Brand name" },
  { id: "website_url", label: "Website URL" },
  { id: "logo_url", label: "Official logo URL" },
  { id: "product_image_url", label: "Product / collection image URL" },
  { id: "tagline_en", label: "Tagline (EN)" },
  { id: "tagline_it", label: "Tagline (IT)" },
  { id: "hairtu_line_en", label: "HAIRTU line (EN)" },
  { id: "hairtu_line_it", label: "HAIRTU line (IT)" },
  { id: "discover_cta_en", label: "Discover CTA (EN)" },
  { id: "discover_cta_it", label: "Discover CTA (IT)" },
  { id: "banner_bg", label: "Banner background (#FFFFFF or #F3F3F3)" },
  { id: "banner_accent", label: "Banner accent (#D8C4A5 / #A8AD94)" },
];

export default function AdminBranding() {
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const r = await axios.get(`${API}/admin/branding`);
    setB(r.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      const payload = FIELDS.reduce((acc, f) => ({ ...acc, [f.id]: b[f.id] || "" }), {});
      await axios.patch(`${API}/admin/branding`, payload);
      toast.success("Branding saved");
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed");
    } finally { setBusy(false); }
  };

  if (!b) return null;

  return (
    <div className="space-y-8" data-testid="admin-branding">
      <div>
        <h1 className="font-serif text-3xl text-[#383633] tracking-tight">KT Milano branding</h1>
        <p className="text-[#6F6B66] mt-1 text-sm">
          Permanent platform identity used across every result, plan, salon PDF and email.
          These assets are protected — partner ads can never replace them.
        </p>
      </div>

      <div className="rounded-2xl bg-white border kt-line p-6">
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-4">Assets & copy</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map((f) => (
            <div key={f.id}>
              <Label htmlFor={f.id} className="text-xs kt-tracking uppercase text-[#6F6B66]">{f.label}</Label>
              <Input
                id={f.id}
                data-testid={`branding-${f.id}`}
                value={b[f.id] || ""}
                onChange={(e) => setB({ ...b, [f.id]: e.target.value })}
                className="mt-2 border-[#ECE7DF] rounded-xl h-11"
              />
            </div>
          ))}
        </div>
        <div className="mt-6 flex justify-end">
          <Button onClick={save} disabled={busy} data-testid="save-branding"
            className="rounded-full bg-[#383633] hover:bg-[#4A4238] text-white h-11 px-6 text-xs kt-tracking uppercase">
            Save branding
          </Button>
        </div>
      </div>

      <div>
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">Preview — small banner</div>
        <KTBanner size="small" lang="en" />
      </div>
      <div>
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">Preview — large identity block</div>
        <KTBanner size="large" lang="en" />
      </div>
    </div>
  );
}
